import React from 'react';
import {Navigate} from 'react-router-dom';
import {isExternalUser} from '../../permissions/usePermissions';

type ProtectedRouteProps = {
  children: React.ReactElement;
  redirectTo?: string;
  requireInternalUser?: boolean;
};

/**
 * Protected route component that handles access control based on user type.
 * - requireInternalUser: Blocks external users (default: /model/list)
 * Admin/Super user routes are protected by usePermissions hook in App.tsx instead.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/model/list',
  requireInternalUser = false,
}) => {
  const externalUser = isExternalUser();

  if (requireInternalUser && externalUser) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
